import type { StoreAppContextInterface } from '~/types/types'
import type { UserStorePorts } from '~/domains/user/UserService'

/**
 * Собирает узкий auth/diary/toasts port из $storeModules, которым уже владеет
 * вызывающий компонент. Возвращает новый объект с перечисленными членами
 * auth/diary/toasts, а не целые модули Vuex — вызывается на каждое обращение, а не
 * в module-scope константу, чтобы SSR не переиспользовал адаптер между запросами
 * разных пользователей. Каждый член состояния собран через get-аксессор на самом
 * себе, а не через аксессор на модуле целиком: доменный сервис деструктурирует
 * порт один раз (`const { auth } = ports`) и читает его поля дальше.
 */
export function useUserStorePorts (
  storeModules: Pick<StoreAppContextInterface, 'auth' | 'diary' | 'toasts'>
): UserStorePorts {
  return {
    auth: {
      get userIdOrNull () {
        return storeModules.auth.userIdOrNull
      },
      get user () {
        return storeModules.auth.user
      }
    },
    diary: {
      get currentUser () {
        return storeModules.diary.currentUser
      }
    },
    toasts: {
      addToast: (...args: Parameters<StoreAppContextInterface['toasts']['addToast']>) =>
        storeModules.toasts.addToast(...args)
    }
  }
}
